import React from 'react';
import Tinymce from "../../../components/tinymce";
import DataLoader from "../../../components/loader/dataLoader";
import defauldIconImage from "../../../assets/images/deafult/default-small-image.png";
import defauldMediaImage from "../../../assets/images/deafult/default-big-image.png";
import useUpdateMediaEevent from "../../../hooks/admin/useUpdateMediaEevent";
import "../../../assets/css/adminPages/mediaEvent/style.scss";


const UpdateMediaEvent = () => {
const {
    data,
    isLoading,
    handleIconChange,
    handleShortDescriptionChange,
    handleImageChange,
    handleUpdate,
    detailDescriptionEditor
} = useUpdateMediaEevent();

    return (
        <div className="media-event-update-section">
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>Media & Event</h1>
                    <div className='content-body'>
                        {isLoading && <DataLoader/>}
                        {data &&
                            <div className='row mx-0'>
                                <div className="col-xl-12">
                                    <div className='form__div-container'>
                                        <div className="media-icon-container">
                                            <img className="media-icon"
                                                 src={data.smallImageBase64 ? `data:image/jpg;base64,${data.smallImageBase64}` : defauldIconImage}
                                                 alt="Icon"
                                            />
                                            <div className="image-uploader">
                                                <label className="icon-update-btn" htmlFor="iconUploader">
                                                    <i className="fa fa-pencil"></i>
                                                </label>
                                                <input
                                                    id="iconUploader"
                                                    className="d-none"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleIconChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12">
                                    <div className='form__div-container'>
                                        <div className="form__div--textarea">
                                          <textarea
                                              className="form__textarea"
                                              placeholder=" "
                                              rows="7"
                                              maxLength="150"
                                              value={data.shortDescription}
                                              onChange={handleShortDescriptionChange}
                                          />
                                            <label htmlFor="" className="textarea-form__label">Short Description</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-12">
                                    <div className='form__div-container media-image-container rounded'>
                                        <div className="image-uploader">
                                            <label className="icon-update-btn" htmlFor="imageUploader">
                                                <i className="fa fa-pencil"></i>
                                            </label>
                                            <input
                                                id="imageUploader"
                                                className="d-none"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                        </div>
                                        <img width="100%"
                                             src={data.detailImageBase64 ? `data:image/jpg;base64,${data.detailImageBase64}` : defauldMediaImage}
                                             className="rounded overflow-hidden"
                                             alt="Media & Event Image"
                                             style={{objectFit: `${data.detailImageBase64 ? 'cover' : 'fill'}`, height: '350px'}}
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-12">
                                    <div className='form__div-container'>
                                        <Tinymce
                                            value={data.detailDescription}
                                            editorRef={detailDescriptionEditor}
                                        />
                                    </div>
                                </div>
                                <div className="col-xl-12 text-right">
                                    <button onClick={handleUpdate} className='save-btn'>Save</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateMediaEvent;
